import { render, staticRenderFns } from "./shoplist.vue?vue&type=template&id=4e778956&"
import script from "./shoplist.vue?vue&type=script&lang=js&"
export * from "./shoplist.vue?vue&type=script&lang=js&"
import style0 from "./shoplist.vue?vue&type=style&index=0&id=4e778956&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports